export default __webpack_public_path__ + "media/components/Pages/Index/Images/Studs-11844431eee10bf934d8a4152f01c799.svg";